import { useSelector } from 'react-redux'
import { getProjects } from 'src/redux/slices/user/endpoints'
import { selectActiveOrganization } from 'src/redux/slices/user/selectors'

import { LinearProgress } from '@material-ui/core'

import Project from './Project'

///// Component
const ProjectList: React.FC = () => {
  const activeOrganization = useSelector(selectActiveOrganization)
  const { data, isLoading } = getProjects.useQuery(activeOrganization, {
    refetchOnMountOrArgChange: true,
  })
  if (isLoading || !data) return <LinearProgress />
  return (
    <>
      {data.map((project) => (
        <Project {...project} key={`project-id-${project.id}`} />
      ))}
    </>
  )
}

export default ProjectList
